import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Navbar from "./Navbar"; // adjust path if needed

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post("http://localhost:4000/api/auth/login", {
        email,
        password,
      });

      // Save token
      localStorage.setItem("token", res.data.token);

      // Go to dashboard
      navigate("/dashboard");
    } catch (err) {
      setError("Invalid email or password");
    }
  };

  return (
    <>
      {/* Navbar */}
      <Navbar />

      {/* Login Section */}
      <div style={container}>
        <div style={box}>
          <h2 style={title}>Lociware Login</h2>

          <p style={subtitle}>Sign in to manage vehicles</p>

          {error && <p style={errorText}>{error}</p>}

          <form onSubmit={handleSubmit}>

            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={input}
            />

            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={input}
            />

            <button type="submit" style={button}>
              Login
            </button>

          </form>
        </div>
      </div>
    </>
  );
}

export default Login;


/* ===================== STYLES ===================== */

const container = {
  minHeight: "calc(100vh - 80px)", // space for navbar
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(to right, #f5f5f5, #eaeaea)",
  padding: "20px",
};

const box = {
  width: "100%",
  maxWidth: "420px",
  padding: "40px 30px",
  background: "#ffffff",
  borderRadius: "12px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
  textAlign: "center",
};

const title = {
  marginBottom: "10px",
  fontSize: "26px",
  fontWeight: "600",
};

const subtitle = {
  marginBottom: "25px",
  color: "#666",
  fontSize: "14px",
};

const errorText = {
  color: "red",
  marginBottom: "15px",
  fontSize: "14px",
};

const input = {
  width: "100%",
  padding: "12px",
  marginBottom: "18px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "14px",
  outline: "none",
};

const button = {
  width: "100%",
  padding: "12px",
  background: "#000",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontSize: "15px",
  cursor: "pointer",
  transition: "0.3s",
};
